import { base } from "@/services/airtable";

export function sendFeedback(name, notes, email, experience, callback) {
  base("feedback").create(
    [
      {
        fields: {
          Name: name,
          Notes: notes,
          Email: email,
          Status: "Todo",
          Experience: experience,
        },
      },
    ],
    function(err, records) {
      callback(err, records);
    }
  );
}
